import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
    return (
        <div className="flex h-screen w-full flex-col overflow-hidden bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 font-display transition-colors">
            <Header />
            <div className="flex flex-1 overflow-hidden">
                <Sidebar />
                <main className="flex-1 overflow-y-auto px-6 pb-6 pt-4 lg:px-10 lg:pb-10 lg:pt-6">
                    <div className="max-w-[1600px] mx-auto w-full flex flex-col gap-8">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
